import { isIOS, isAndroid, isFirefox } from "react-device-detect";
import { Option } from "@gocardless/flux-react";

import { PopularCountryCodes } from "../../consts";
import { CountryData } from "../../helper";

interface CountryOptionsType {
  countriesData: CountryData[];
  isOpen: boolean;
}

export const CountryOptions = ({
  countriesData,
  isOpen,
}: CountryOptionsType) => {
  const options = countriesData?.map(({ name, code }, index) => {
    if (isIOS || isFirefox) {
      return (
        <Option key={code} value={code}>
          {`${code} - ${name}`}
        </Option>
      );
    }
    if (isAndroid) {
      return (
        <Option key={code} value={code}>
          {isOpen ? `${code} - ${name}` : code}
        </Option>
      );
    }

    return (
      <>
        <Option key={code} value={code}>
          {`${code} - ${name}`}
        </Option>
        {index === PopularCountryCodes.length - 1 && <hr />}
      </>
    );
  });

  return <>{options}</>;
};
